import { render, staticRenderFns } from "./ContentsListNew.vue?vue&type=template&id=1dff8ce9&scoped=true"
import script from "./ContentsListNew.vue?vue&type=script&lang=js"
export * from "./ContentsListNew.vue?vue&type=script&lang=js"
import style0 from "./ContentsListNew.vue?vue&type=style&index=0&id=1dff8ce9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dff8ce9",
  null
  
)

export default component.exports